import ContentIcon from "@/shared/ContentIcon";
import { ModalDialog, ModalOverlay, NotificationButton, ModalHeader, ModalBody } from "./styles";
import { NewsNotifications, Settings, UserNotifications } from "./components";
import { useNotifications } from "./context";

const NotificationsUI = () => {
  const {
    isOpen,
    isClosing,
    activeTab,
    setActiveTab,
    openModal,
    closeModal,
    notifications,
  } = useNotifications();

  return (
    <>
      <NotificationButton
        onClick={openModal}
         className={`notification-btn ${
          notifications.filter((n) => !n.read).length > 0 ? "has-notifications" : ""
        }`}
      >
        <ContentIcon width="30" height="30" nameIcon="bell"/>
      </NotificationButton>
      {(isOpen || isClosing) && (
        <ModalOverlay onClick={closeModal}>
          <ModalDialog open className={isClosing ? "isClosing" : ""} onClick={(e) => e.stopPropagation()}>
            <ModalHeader>
              <h2>Notificaciones</h2>
              <button onClick={closeModal}>
                <ContentIcon width="18" height="18" nameIcon="closeIco"/>
              </button>
            </ModalHeader>
            <ul>
              <li 
                className={activeTab === 1 ? "active" : ""}
                onClick={() => setActiveTab(1)}
              >
                Notificaciones
              </li>
              {/* <li 
                className={activeTab === 2 ? "active" : ""}
                onClick={() => setActiveTab(2)}
              >
                Usuario
              </li> */}
              <li 
                className={activeTab === 3 ? "active" : ""}
                onClick={() => setActiveTab(3)}
              >
                Configuración
              </li>
            </ul>
            <ModalBody>
              {activeTab === 1 && <NewsNotifications />}
              {/* {activeTab === 2 && <UserNotifications />} */}
              {activeTab === 3 && <Settings />}  
            </ModalBody>

          </ModalDialog>
        </ModalOverlay>
      )}
    </>
  );
};

const Notifications = () => {
  return <NotificationsUI />;
};

export default Notifications;
